import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { FieldValues, UseFormProps } from 'react-hook-form/dist/types';
import { UnpackNestedValue } from 'react-hook-form/dist/types/form';

interface Props<TFieldValues extends FieldValues = FieldValues, TContext = any>
  extends UseFormProps<TFieldValues, TContext> {
  onUpdate?: (value: UnpackNestedValue<TFieldValues>) => void;
}
export const useFilterForm = <TFieldValues extends FieldValues = FieldValues, TContext = any>(
  props: Props<TFieldValues, TContext>,
) => {
  const result = useForm(props);

  const { defaultValues, onUpdate } = props;

  const { reset, getValues } = result;

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const onChangeItem = useCallback(() => {
    if (JSON.stringify(defaultValues) !== JSON.stringify(getValues())) {
      onUpdate && onUpdate(getValues());
    }
  }, [getValues, defaultValues, onUpdate]);

  return { ...result, onChangeItem };
};
